<template>
  <div class="summary locked">
    <div class="content-header">
      <h2>Your Summary</h2>
      <div>
        <p>
          This is the final list of notes and questions you created. We
          recommend you bring this to your upcoming appointment to help you
          remember the most important things you want to discuss.
        </p>
        <ul>
          <li>
            <strong>Print the list</strong> by using the button at the bottom of
            the screen
          </li>
          <li>
            Sign in later and <strong>view it electronically</strong> from your
            phone or tablet
          </li>
        </ul>
        <p>You can also return to the site and start a new list.</p>
      </div>
    </div>

    <main>
      <article class="questions-list">
        <section class="summary">
          <h2>My Questions and Concerns</h2>
          <h3>Clarifying what I want to discuss with my doctor</h3>
          <summary-list valueKey="QuestionsConcerns" :initial="summaryResponses.QuestionsConcerns" :removable="false"
            :locked="true" />
        </section>
      </article>

      <article class="topics-list grid-section">
        <section>
          <h2>My Situation</h2>
          <h3>Clarifying the facts about my condition</h3>
          <h4>My cancer</h4>
          <p v-if="
            summaryResponses.CancerType &&(
            summaryResponses.CancerType.question === undefined ||
            summaryResponses.CancerType.question.length === 0)
          ">
            You mentioned that you didn't know your cancer type.
          </p>

          <summary-field valueKey="CancerType" :initial="summaryResponses.CancerType" :removable="false"
            :locked="true" />

          <h4>Details about my cancer</h4>

          <summary-list valueKey="CancerDetails" :initial="summaryResponses.CancerDetails" :removable="false"
            :locked="true" />

          <h4>My health situation</h4>
          <p v-if="
            summaryResponses.OverallHealth &&(
            summaryResponses.OverallHealth.question === undefined ||
            summaryResponses.OverallHealth.question.length === 0)
          ">
            You didn't add any details about your current health situation.
          </p>
          <summary-list valueKey="OverallHealth" :initial="summaryResponses.OverallHealth" :removable="false"
            :locked="true" />
        </section>

        <section>
          <h2>My Options</h2>
          <h3>Clarifying my treatment options</h3>
          <h4>My treatment options</h4>
          <p v-if="summaryResponses.dontKnowTreatment">
            You mentioned that you didn't know your treatment options.
          </p>
          <summary-list valueKey="OptionsDetails" :initial="summaryResponses.OptionsDetails" :removable="false"
            :locked="true" />
        </section>

        <section>
          <h2>My Support</h2>
          <h3>Clarifying who can help me</h3>
          <h4>My medical network</h4>
          <p v-if="summaryResponses.dontKnowMedicalTeam">
            You mentioned that you didn't know who was on your medical team.
          </p>
          <summary-list valueKey="SupportMedical" :initial="summaryResponses.SupportMedical" :removable="false"
            :locked="true" />
          <h4>My personal network</h4>
          <p v-if="summaryResponses.noPersonalSupport">
            You mentioned that you didn't know anyone in your personal life that
            could help you.
          </p>
          <summary-list valueKey="SupportPersonal" :initial="summaryResponses.SupportPersonal" :removable="false"
            :locked="true" />
        </section>

        <section>
          <h2>My Goals and Priorities</h2>
          <h3>Clarifying what's important to me</h3>
          <div v-for="(value, index) in summaryResponses.values" :key="index">
            <h4 v-html="value.question" />
            <summary-list valueKey="'values_list' + '.' + value.question"
              :initial="summaryResponses.values_list[value.question]" :removable="false" :locked="true" />
          </div>
        </section>
      </article>
    </main>
    <footer class="content-footer">
      <a @click="showModal = true" class="button mr-4">Send Email</a>
      <a @click="printSummary" class="button mr-4">Print my summary</a>
      <button @click="backToProfile" v-html="doneButtonName"></button>
    </footer>

    <modal v-if="showModal" @close="showModal = false">
      <template v-slot:modalName>
        <h2>Send Email</h2>
      </template>
      <template v-slot:modalBody>
        <p>Select email text here... </p>
        <input id="email" name="email" type="email" v-model="emailSelected" placeholder="type your email address here"
          class="form-control input-md" required>

      </template>

      <template v-slot:modalFooter>
        <button type="button" @click="showModal = false" aria-label="Close modal">cancel</button>&nbsp;
        <button type="button" @click="sendEmail">Send</button>
      </template>
    </modal>

  </div>
</template>

<style scoped>
.content-footer {
  box-shadow: 0 -5px 7px 0 rgba(0, 0, 0, 0.26);
  display: flex;
  justify-content: center;
}
</style>

<script>
import SummaryField from "@/components/SummaryField.vue";
import SummaryList from "@/components/SummaryList.vue";
import { mapState, mapMutations } from "vuex";
import { axios } from "@/main.js";
import modal from '@/components/modal.vue';
import { DateTime } from "luxon";
import store from "../store";

//export const axios = require('axios').default;
//axios.defaults.baseURL = "https://api.open2options.org";
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
//axios.defaults.xsrfHeaderName = "X-CSRFToken";
//axios.defaults.xsrfCookieName = "csrftoken";


export default {
  name: "LockedSummary",

  props: {
    mode: String, // situation, options, network, goals, evaluation, or final,
  },

  data() {
    return {
      currentMode: this.mode,
      isModalVisible: false,
      showModal: false,
      emailSelected: '',
      errors: []
    };
  },
  mounted() {
    this.updateSessionList();
    this.getProfile();
  },

  created() {
    this.createSummaryResponses("final");
  },
  computed: {
    ...mapState([
      "summaryResponses",
      "chatResponses",
      // "arm",
      "accessCode",
      "baselineDateTime",
      "sessionID",
    ]),

    doneButtonName() {
      return "Back to my profile";
    },
  },

  methods: {
    ...mapMutations(["createSummaryResponses", "setSessionFinalized", "resumeSession", "viewSession", "setServerChatSessionID"]),

    getProfile() {
      let profile_url = "/api/profile/";
      let self = this;

      axios
        .get(profile_url)
        .then(function (response) {
          self.emailSelected = response.data["email"];
        })
        .catch(function (error) {
          console.log(error);
          window.location.replace("/login");
        });
    },
    resume(session) {
      this.setServerChatSessionID(session.id);
      var summaryResponses = {};
      var chatResponses = {};

      let section = session.current_section_name || "situation";
      if (session.summary_responses.length > 0) {
        summaryResponses = JSON.parse(session.summary_responses);
      }

      if (session.chat_responses.length > 0) {
        chatResponses = JSON.parse(session.chat_responses);
      }

      this.resumeSession({
        sectionName: section,
        summaryResponses: summaryResponses,
        chatResponses: chatResponses
      });

      this.$router.push("/chat/" + section + "/new/");
    },
    view(session) {
      this.setServerChatSessionID(session.id);
      this.setSessionFinalized(new Date(session.finalized));

      var summaryResponses = {};
      var chatResponses = {};

      if (session.summary_responses.length > 0) {
        summaryResponses = JSON.parse(session.summary_responses);
      }

      if (session.chat_responses.length > 0) {
        chatResponses = JSON.parse(session.chat_responses);
      }

      this.viewSession({
        summaryResponses: summaryResponses,
        chatResponses: chatResponses
      });

      this.$router.push("/summary/locked/");
    },

    updateSessionList() {
      let sessions_url = "/api/chat/sessions/";
      let QSessionId = document.cookie.split('; ').find((row) => row.startsWith('QSessionId=')).split('=')[1];
      let self = this;
      if (QSessionId) {
        axios
          .get(sessions_url)
          .then(function (response) {
            let sessions = [];
            for (let index in response.data) {
              let session = response.data[index];
              session.date = DateTime.fromISO(session.created).toLocaleString(
                DateTime.DATETIME_MED
              );
              sessions.push(session);
            }
            let sessionCached = sessions.find(x => x.id == QSessionId)
            if (sessionCached.finalized) {
              self.view(sessionCached)
            } else {
              self.resume(sessionCached)
            }

          })
          .catch(function (error) {
            console.log(error);
            window.location.replace("/login");
          });
      }
    },

    backToProfile() {
      window.location.replace("#/profile");
    },

    printSummary() {
      let url = "/save_event/" + this.accessCode + "/";
      var formData = new FormData();

      formData.set("event_name", "Print");
      formData.set("note", "Printing summary for session " + this.sessionID);

      axios.post(url, formData).then(function (response) {
        let status = response.status;

        switch (status) {
          case 200: // success
            print();
            break;

          default:
            break;
        }
      });
    },

    sendEmail() {
      this.showModal = false
      let self = this;

      if (!this.emailSelected || this.emailSelected == '') {
        this.errors.push("Please enter an email");
        console.log('Please enter an email"')
        return;
      }
        let url = "/api/sendemail/";
        axios
          .post(url, { mailTo: this.emailSelected, sessionId: this.sessionID.toString() })
          .then(function (response) {
            let status = response.status;

            switch (status) {
              case 200:


                break;

              default:
                break;
            }
          })
          .catch(function (error) {
            let status = error.response.status;
            self.errors.push[error.response.statusText];
            switch (status) {
              case 400:

                self.errors = error.response.data;
                console.log('self.errors', self.errors)

                break;

              default:
                break;
            }
          });
    
    },
  },


  components: {
    "summary-field": SummaryField,
    "summary-list": SummaryList,
    modal
  },
};
</script>
